// CalendarComponent.js
import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleIcon from "@mui/icons-material/People";
import EventIcon from "@mui/icons-material/Event";
import Box from "@mui/material/Box";
import { ReactMultiEmail } from "react-multi-email";
import FormControlLabel from "@mui/material/FormControlLabel";
import TeamsIcon from "../images/TeamsIcon.png";
import Switch from "@mui/material/Switch";
import Select from "@mui/material/Select";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import MenuItem from "@mui/material/MenuItem";
import { userSelector } from "../user-redux/selector";
import { useTheme } from "@mui/material/styles";
import { CiUser } from "react-icons/ci";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToastMessage from ".././ToastMessage.js";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { format, utcToZonedTime } from "date-fns-tz";
import { useMediaQuery, Paper, Divider, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import Key from "../../clientVariables.json";
import "../styles/Calander.css";
import { loginRequest } from "../../helpers/msalConfig.js";

const localizer = momentLocalizer(moment);

const CalendarComponent = () => {
  let isProduction = window.location.href.toString().substring(0, 5);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets

  let Domain = `${isProduction === "http:" ? Key.domain : "http://localhost:7758"
    }`;
  const { user } = useSelector(userSelector);
  const [interviewEvents, setInterviewEvents] = useState([]);
  const [openInterviewDialog, setOpenInterviewDialog] = useState(false);
  const [selectedInterview, setSelectedInterview] = useState(null);

  // states handling
  const { accounts, instance } = useMsal();
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [events, setEvents] = useState([]);
  const [start, setStart] = useState(); // Initialize with a default date object
  const [end, setEnd] = useState();
  const [SelectedEventDate, setSelectedEventDate] = useState(undefined);
  const [openCreateEventDialog, setOpenCreateEventDialog] = useState(false);
  const [attendees, setAttendees] = useState([]);
  const [accessToken, setAccessToken] = useState(null);
  const [isTeamsMeeting, setIsTeamsMeeting] = useState(false);
  const [openEditBox, setOpenEditBox] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState("");
  const [openEditCalanderEventsDialog, setOpenEditCalanderEventsDialog] =
    useState(false);
  const [isSelectedOpenDialogBox, setIsSelectedOpenDialogBox] =
    useState("create");

  const [eventDetails, setEventDetails] = useState({
    start: undefined,
    end: undefined,
    eventStartTime: undefined,
    eventEndTime: undefined,
    desc: "",
    eventTimeZone: "Asia/Kolkata",
    eventDate: "",
    eventCreateDate: "",
    iniviteAttendees: attendees,
    teamsLink: "",
    title: "",
    eventId: "",
  });
  const [slotDetails, setSlotDetails] = useState({});

  const [selectedDayEvents, setSelectedDayEvents] = useState([]);

  // msal login dialog box
  const [openSlot, setOpenSlot] = useState(false);

  // ===================  UI functionalities  =======================

  const handleSelectedEvent = (eventInfo) => {
    // Handle interview events differently
    if (eventInfo.eventType === 'interview') {
      // Show interview details in a beautiful dialog
      setSelectedInterview(eventInfo.interviewData);
      setOpenInterviewDialog(true);
      return;
    }

    // Handle regular calendar events
    const date = new Date(eventInfo.start);
    date.setDate(date.getDate());
    const isoDateString =
      date.toISOString().split("T")[0] +
      `${isProduction === "http:" ? "T00:00:00.000Z" : "T18:30:00.000Z"}`;
    let getEventsOnParticularDay = events.filter((data) => {
      return data.event_date === isoDateString;
    });

    if (
      getEventsOnParticularDay.length > 0 &&
      eventInfo.eventType !== "USHoliday"
    ) {
      // converting eventInfo.inviteAttendees into array using ,
      setSelectedDayEvents(getEventsOnParticularDay);
      let getAttendees = eventInfo.iniviteAttendees.split(",");
      setAttendees(getAttendees);
      setEventDetails({
        start: eventInfo.start,
        eventDate: eventInfo.eventDate,
        end: eventInfo.end,
        desc: eventInfo.desc,
        eventTimeZone: eventInfo.eventTimeZone,
        eventCreateDate: eventInfo.eventCreateDate,
        iniviteAttendees: attendees,
        teamsLink: eventInfo.teamsLink,
        title: eventInfo.title,
        eventStartTime: eventInfo.eventStartTime,
        eventEndTime: eventInfo.eventEndTime,
        eventId: eventInfo.eventId,
      });
      setSlotDetails((prev) => ({ ...prev, start: eventInfo.start }));
      setOpenEditBox(true);
    } else {
      window.alert("not allowed to edit");
    }
  };

  const handleSlotSelected = async (slotInfo) => {
    let msg = "opened";
    toast(<ToastMessage message={msg} />);
    setAttendees([]);

    const parsedDate = moment(slotInfo.start);
    const formattedDate = parsedDate.format("YYYY-MM-DD HH:mm:ss");
    setSlotDetails(slotInfo);
    setSlotDetails((prev) => ({ ...prev, start: formattedDate }));
    setSelectedEventDate(formattedDate);

    if (accounts.length === 0) {
      await msalLogin();
      setOpenCreateEventDialog(true);
      // setOpenSlot(true);
    } else {
      setOpenSlot(true);
    }
  };

  const handleClose = () => {
    setOpenCreateEventDialog(false);
    setOpenEditCalanderEventsDialog(false);
    setOpenEditBox(false);
    if (isSelectedOpenDialogBox === "edit") {
      setIsSelectedOpenDialogBox("create");
    }

    setEventDetails({
      start: undefined,
      end: undefined,
      desc: "",
      eventTimeZone: "Asia/Kolkata",
      eventCreateDate: "",
      iniviteAttendees: attendees,
      teamsLink: "",
      title: "",
      eventId: "",
    });
  };

  const appointmentActions = (
    <div className="container" style={{ textAlign: "center" }}>
      <Button
        key="cancel"
        variant="contained"
        color="secondary"
        onClick={handleClose}
        style={{ backgroundColor: "#FFF", color: "#000", margin: "5px" }}
      >
        Cancel
      </Button>
      <Button
        key="save"
        type="submit"
        variant="contained"
        onClick={() => {
          insertOrUpdateCalander(1);
          handleClose();
        }}
        style={{
          border: "1px solid #FFF",
          color: "#FFF",
          backgroundColor: "#406882",
          margin: "5px",
        }}
      >
        {/* {attendees.length > 0 ? "SEND" : "SAVE"} */}
        Save{" "}
      </Button>
    </div>
  );

  const getCurrentTime = (timeZone) => {
    const now = new Date();
    const formattedTime = format(utcToZonedTime(now, timeZone), "HH:mm:ss", {
      timeZone,
    });
    setStart(formattedTime.slice(0, 5));
    setEnd(formattedTime.slice(0, 5));
    // return formattedTime;
  };

  // ===================  UI END functionalities  =======================

  // =================  api integration funcitons  ======================

  const fetchEventsByUid = async (userId) => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    // let url = `${Domain}/calander/getCalanderEventByUid/${userId}`; // replace when real inserted
    let url = `${Domain}/calander/getCalanderEventByUid/${userId}`;

    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const error = await response.text();
      console.log(error);
      return;
    }
    const data = await response.json();
    if (data.message == "success") {
      let results = data.result;
      setEvents(results);
    }
  };

  function getCurrentdate() {
    const currentDate = new Date(); // Get the current date
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Adding 1 because January is 0
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} 00:00:00`;
    return formattedDate;
  }

  const insertOrUpdateCalander = async (
    action_status,
    appointment,
    msalEventData
  ) => {
    setAttendees([]);
    // window.alert(action_status);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      id: eventDetails.eventId, // only used for updation
      uid: user.id,
      event_name: eventDetails.title,
      event_description: eventDetails.desc,
      event_date:
        action_status == 1
          ? slotDetails.start
          : covertDateAndTimeToZero(eventDetails.eventDate),
      event_starttime: eventDetails.eventStartTime,
      event_endtime: eventDetails.eventEndTime,
      event_time_zone: eventDetails.eventTimeZone,
      event_type: attendees.length > 0 ? "MsalEvent" : "PersonalEvent",
      invite_attendees: attendees,
      created:
        action_status == 1
          ? getCurrentdate()
          : covertDateAndTimeToZero(eventDetails.eventCreateDate),
      teams_meeting_link: isTeamsMeeting && msalEventData && msalEventData.onlineMeeting ? msalEventData.onlineMeeting.joinUrl : "",
      msal_event_id: msalEventData && msalEventData.id ? msalEventData.id : "",
      action_status: action_status,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    let url = `${Domain}/calander/createORupdateEvent`;

    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      if (setIsSelectedOpenDialogBox === "edit") {
        isSelectedOpenDialogBox("create");
      }
      return;
    }
    const data = await response.json();
    if (data.message == "success") {
      if (setIsSelectedOpenDialogBox === "edit") {
        isSelectedOpenDialogBox("create");
      }
      if (action_status == 0) {
        setSelectedDayEvents([]);
      }
      fetchEventsByUid(user.id);
    }
  };

  function covertDateAndTimeToZero(dateString) {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day} 00:00:00`;
  }

  const deleteCalanderEventByUid = async (id) => {
    handleClose();
    const requestOptions = {
      method: "POST",
      redirect: "follow",
    };

    let url = `${Domain}/calander/deleteCalanderEventById/${id}`;
    let response = await fetch(url, requestOptions);

    if (!response.ok) {
      let error = await response.text();
      console.log(error);
      if (setIsSelectedOpenDialogBox === "edit") {
        isSelectedOpenDialogBox("create");
      }
    }
    const data = await response.json();
    if (data.message == "success") {
      setSelectedDayEvents([]);
      if (setIsSelectedOpenDialogBox === "edit") {
        isSelectedOpenDialogBox("create");
      }
      setAttendees([]);
      fetchEventsByUid(user.id); // edit this with the user id
    }
  };
  const fetchMsalAccountsData = async () => {
    try {
      // Acquire token silently
      instance.setActiveAccount(user);
      const response = await instance.acquireTokenSilent({
        account: accounts[0],
        scopes: loginRequest,
      });
      // Set the access token in state
      setAccessToken(response.accessToken);
    } catch (error) {
      console.error("Error acquiring token:", error);
    }
  };
  // const fetchMsalAccountsData = async () => {
  //   try {
  //     // Acquire token silently
  //     const response = await instance.acquireTokenSilent({
  //       account: accounts[0],
  //       scopes: ["User.Read", "Calendars.ReadWrite"],
  //     });

  //     // If token is acquired successfully, set the access token in state
  //     setAccessToken(response.accessToken);
  //   } catch (error) {
  //     // If an error occurs, check if it is due to interaction_required error
  //     if (error.name === "InteractionRequiredAuthError") {
  //       // If interaction is required, prompt the user to sign in again using a popup
  //       try {
  //         const response = await instance.acquireTokenPopup({
  //           scopes: ["User.Read", "Calendars.ReadWrite"],
  //         });
  //         // If token is acquired successfully after prompting, set the access token in state
  //         setAccessToken(response.accessToken);
  //       } catch (popupError) {
  //         console.error("Error acquiring token using popup:", popupError);
  //       }
  //     } else {
  //       // Handle other types of errors
  //       console.error("Error acquiring token silently:", error);
  //     }
  //   }
  // };

  const msalLogin = async (appointment) => {
    try {
      // Check if there is an interaction in progress
      // if (!instance.getAccount()) {
      // If no interaction is in progress, initiate the login popup
      await instance.loginPopup({
        scopes: Key.azure_scopes,
        prompt: "select_account",
      });
      // }

      // Once the login is successful, create the Msal event
      await createMsalEvent(appointment);
    } catch (error) {
      console.error(error);
    }
  };

  const createMsalEvent = async (appointment) => {
    const graphEndpoint = "https://graph.microsoft.com/v1.0/me/events/";

    const newattendees = attendees.map((email) => {
      const [name, domain] = email.split("@");

      return {
        emailAddress: {
          address: email,
          name: name,
        },
        type: "required",
      };
    });

    const eventPayload = {
      subject: eventDetails.title,
      body: {
        contentType: "TEXT",
        content: eventDetails.desc,
      },
      // handle after the issue get fixed
      // start: {
      //   dateTime:
      //     eventDetails.eventStartTime == "00:00"
      //       ? moment(`${slotDetails.start} ${timeValue}`).format("YYYY-MM-DD HH:mm:ss")
      //       : moment(`${slotDetails.start} ${eventDetails.eventStartTime}`).format("YYYY-MM-DD HH:mm:ss"),
      //   timeZone: eventDetails.eventTimeZone,
      // },
      // end: {
      //   dateTime:
      //     end == "00:00"
      //       ? moment(`${selectDate} ${timeValue}`).format("YYYY-MM-DD HH:mm:ss")
      //       : moment(`${selectDate} ${end}`).format("YYYY-MM-DD HH:mm:ss"),
      //   timeZone: selectedTimeZone,
      // },
      attendees: newattendees,
      isOnlineMeeting: isTeamsMeeting,
    };

    try {
      const response = await fetch(graphEndpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(eventPayload),
      });

      if (response.ok) {
        const msalEventData = await response.json();
        await insertOrUpdateCalander(1, appointment, msalEventData);
      } else {
        alert("Please try creating event");
        console.error("Error creating event:", response.statusText);
      }
    } catch (error) {
      console.error("Error creating event:", error);
    }
  };

  // =============== use Effects ==============

  useEffect(() => {
    fetchMsalAccountsData();
  }, [accounts, instance]);

  useEffect(() => {
    fetchEventsByUid(user.id);
    fetchInterviewData();
  }, []);

  const fetchInterviewData = async () => {
    try {
      // Check if user has candidate_id (for candidates) or use recruiter endpoint
      let apiUrl;
      if (user?.candidate_id) {
        apiUrl = `${Key.domain}/candidate/${user.candidate_id}/scheduled_interviews`;
      } else {
        apiUrl = `${Key.domain}/submission/${user.id}/scheduled_interviews`;
      }

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();
      const interviews = data?.data?.interviews || [];

      const toLocalDateAtNoon = (yyyy_mm_dd) => {
        const [y, m, d] = yyyy_mm_dd.split('-').map(Number);
        return new Date(y, m - 1, d, 12, 0, 0, 0);
      };

      const interviewCalendarEvents = interviews
        .filter(i => i.interview_date && i.interview_date !== "Invalid date")
        .map((i, idx) => ({
          start: toLocalDateAtNoon(i.interview_date),
          end: toLocalDateAtNoon(i.interview_date),
          allDay: true,
          title: `Interview: ${i.jobtitle || 'Job Interview'}`,
          desc: `Interview with ${i.client_name || 'Client'}`,
          eventType: 'interview',
          interviewData: i,
          id: `interview_${i.id ?? idx}`,
        }));

      setInterviewEvents(interviewCalendarEvents);
    } catch (error) {
      console.error("Error fetching interview data:", error);
    }
  };

  // Custom event styling function
  const eventPropGetter = (event) => {
    let backgroundColor = '#3174ad'; // Default color for regular events
    let borderColor = '#3174ad';
    let color = 'white';

    if (event.eventType === 'interview') {
      backgroundColor = '#2563eb'; // Red color for interviews
      borderColor = '#2563eb';
      color = 'white';
    }

    return {
      style: {
        backgroundColor,
        borderColor,
        color,
        border: `2px solid ${borderColor}`,
        borderRadius: '5px',
        fontWeight: 'bold',
      }
    };
  };

  // Format time to AM/PM with timezone
  // const formatTimeWithTimezone = (timeString) => {
  //   if (!timeString) return 'N/A';

  //   try {
  //     // Handle different time formats
  //     let time;

  //     // If time is in HH:MM format, create a date object for today with that time
  //     if (timeString.match(/^\d{1,2}:\d{2}$/)) {
  //       const today = new Date();
  //       const [hours, minutes] = timeString.split(':');
  //       time = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(hours), parseInt(minutes));
  //     }
  //     // If time is in HH:MM:SS format
  //     else if (timeString.match(/^\d{1,2}:\d{2}:\d{2}$/)) {
  //       const today = new Date();
  //       const [hours, minutes, seconds] = timeString.split(':');
  //       time = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(hours), parseInt(minutes), parseInt(seconds));
  //     }
  //     // If it's already a full datetime string
  //     else {
  //       time = new Date(timeString);
  //     }

  //     // Format to 12-hour format with AM/PM (without timezone)
  //     const formattedTime = time.toLocaleTimeString('en-US', {
  //       hour: 'numeric',
  //       minute: '2-digit',
  //       hour12: true
  //     });

  //     return formattedTime;
  //   } catch (error) {
  //     console.error('Error formatting time:', error);
  //     return timeString; // Return original if formatting fails
  //   }
  // };

  // Format date with timezone
  const TZ_MAP = {
    IST: "Asia/Kolkata",
    EST: "America/New_York",
    EDT: "America/New_York",
    CST: "America/Chicago",
    CDT: "America/Chicago",
    MST: "America/Denver",
    MDT: "America/Denver",
    PST: "America/Los_Angeles",
    PDT: "America/Los_Angeles",
    GMT: "Etc/GMT",
    UTC: "UTC",
  };

  const formatDateWithTimezone = (dateString, timeString = null, tz = null) => {
    if (!dateString) return "N/A";

    // ===== Case 1: DATE ONLY (no time / tz) =====
    if (!timeString || !tz) {
      // Build a UTC date from Y-M-D to avoid local timezone shifts
      const [y, m, d] = dateString.split("-").map(Number);
      const dateUTC = new Date(Date.UTC(y, (m || 1) - 1, d || 1));

      return new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC", // keep it pinned, no shift
      }).format(dateUTC);
    }

    // ===== Case 2: DATE + TIME + TZ =====
    // Accept IANA tz directly or fall back to abbreviation map
    const timeZone = TZ_MAP[tz] || tz;

    // Create a base Date from the ISO-like string (interpreted in UTC baseline)
    const date = new Date(`${dateString}T${timeString}`);

    return (
      new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone,
      }).format(date) + ` ${tz}`
    );
  };

  return (
    <div id="Calendar" style={{ padding: "1vw" }}>
      <div className="row">
        <div className="row">
          <div
            className={isMobile || isTablet ? "col-12" : "col-9"}
            style={{ height: "80vh" }}
          >
            <Calendar
              localizer={localizer}
              events={[
                // Regular calendar events
                ...events.map((data) => {
                  return {
                    start: new Date(data.event_date),
                    end: new Date(data.event_date),
                    eventStartTime: data.event_starttime,
                    eventEndTime: data.event_endtime,
                    desc: data.event_description,
                    eventTimeZone: data.event_time_zone,
                    eventDate: data.event_date,
                    eventCreateDate: data.created,
                    iniviteAttendees: data.invite_attendees,
                    teamsLink: data.teams_meeting_link,
                    title: data.event_name,
                    eventId: data.id,
                    msalEventId: data.msal_event_id,
                    eventType: data.event_type,
                  };
                }),
                // Interview events
                ...interviewEvents
              ]}
              onSelectEvent={(e) => handleSelectedEvent(e)}
              onSelectSlot={(e) => handleSlotSelected(e)}
              defaultView="month"
              selectable={true}
              timeslots={2}
              startAccessor="start"
              endAccessor="end"
              eventPropGetter={eventPropGetter}
              style={{ margin: "1vw" }}
            />
          </div>

          <div className={isMobile || isTablet ? "col-12" : "col-3"}>
            <Box sx={{ p: 2 }}>
              <Paper elevation={3} sx={{ p: 3, minHeight: 300, borderRadius: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#406882' }}>
                  Meetings for the selected day
                </Typography>
                <Divider sx={{ mb: 2 }} />
                {selectedDayEvents && selectedDayEvents.length > 0 ? (
                  <List>
                    {selectedDayEvents.map((event, idx) => (
                      <Box key={idx}>
                        <ListItem alignItems="flex-start">
                          <ListItemIcon>
                            <EventIcon color="primary" />
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                {event.event_name || event.title}
                              </Typography>
                            }
                            secondary={
                              <>
                                <Typography variant="body2" color="text.secondary">
                                  {event.event_starttime} - {event.event_endtime}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  Organizer: {event.organizer || user?.name}
                                </Typography>
                                {event.invite_attendees && event.invite_attendees.length > 0 && (
                                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                    <PeopleIcon fontSize="small" sx={{ mr: 0.5 }} />
                                    <Typography variant="body2" color="text.secondary">
                                      {Array.isArray(event.invite_attendees) ? event.invite_attendees.join(', ') : event.invite_attendees}
                                    </Typography>
                                  </Box>
                                )}
                              </>
                            }
                          />
                        </ListItem>
                        {idx < selectedDayEvents.length - 1 && <Divider variant="inset" component="li" />}
                      </Box>
                    ))}
                  </List>
                ) : (
                  <Box sx={{ textAlign: 'center', mt: 6, color: 'text.secondary' }}>
                    <InfoOutlinedIcon sx={{ fontSize: 48, mb: 1 }} color="disabled" />
                    <Typography variant="body1">No meeting slots available for the selected day.</Typography>
                  </Box>
                )}
              </Paper>
            </Box>
          </div>
        </div>
      </div>

      {/* Material-ui Modal for creating New Event*/}
      <Dialog
        open={openCreateEventDialog}
        onClose={handleClose}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        PaperProps={{ style: { overflow: "hidden" } }}
      >
        <DialogTitle
          style={{
            backgroundColor: "#406882",
            color: "#FFF",
            fontWeight: "lighter",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            {isSelectedOpenDialogBox === "create" &&
              `Create Meeting on ${moment(slotDetails.start).format(
                "MMMM Do YYYY"
              )}`}
            {isSelectedOpenDialogBox === "edit" &&
              `Edit Meeting on ${moment(eventDetails.start).format(
                "MMMM Do YYYY"
              )}`}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Grid
          container
          spacing={2}
          style={{ border: "1px lightgrey", padding: "20px" }}
        >
          <Grid item xs={12}>
            <TextField
              label="Title *"
              value={eventDetails.title}
              onChange={(e) =>
                setEventDetails((prev) => ({ ...prev, title: e.target.value }))
              }
              variant="standard"
              fullWidth
              size="small"
            />
            <br />

            <div>
              <label className="mt-2" style={{ color: "gray" }}>
                Invite Attendees
              </label>
              <div
                style={{
                  display: "flex",
                  borderBottom: "1px solid grey",
                }}
              >
                <ReactMultiEmail
                  placeholder=""
                  emails={attendees}
                  name="cc"
                  style={{
                    borderBottom: "none",
                    width: "20vw",
                    color: "red",
                  }}
                  onChange={(emails) => {
                    setAttendees(emails);
                  }}
                  getLabel={(email, index, removeEmail) => {
                    return (
                      <div
                        data-tag
                        key={index}
                        style={{
                          width: "25vw",
                          display: "flex",
                          border: "5px solid red",
                          outline: "none",
                          border: "1px solid red !important",
                          background: "transparent !important",
                        }}
                      >
                        <div
                          data-tag-item
                          style={{
                            width: "100% !important",
                            background: "transparent !important",
                            color: "black !important",
                            border: "1px solid red",
                          }}
                        >
                          {email}
                        </div>
                        <span
                          data-tag-handle
                          onClick={() => removeEmail(index)}
                          style={{ cursor: "pointer" }}
                        >
                          ×
                        </span>
                      </div>
                    );
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        onChange={() => setIsTeamsMeeting(!isTeamsMeeting)}
                      />
                    }
                    label={
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#757575",
                          fontWeight: 500,
                        }}
                      >
                        Teams Meeting
                      </span>
                    }
                  />
                  <img
                    src={TeamsIcon}
                    style={{ width: "25px", height: "25px" }}
                  />
                </div>
              </div>
            </div>

            <TextField
              id="standard-multiline-static"
              label="Description"
              multiline
              rows={4}
              value={eventDetails.desc}
              onChange={(e) =>
                setEventDetails((prev) => ({ ...prev, desc: e.target.value }))
              }
              fullWidth
              size="small"
              variant="standard"
              style={{ marginBottom: "10px" }}
            />
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={eventDetails.eventTimeZone}
              onChange={(e) => {
                setEventDetails((prev) => ({
                  ...prev,
                  eventTimeZone: e.target.value,
                }));
                getCurrentTime(e.target.value);
              }}
              label="TimeZone"
              style={{ margin: "5px 10px" }}
            >
              <MenuItem value="America/Denver">MST</MenuItem>
              <MenuItem value="America/Chicago">CST</MenuItem>
              <MenuItem value="America/Los_Angeles">PST</MenuItem>
              <MenuItem value="America/New_York">EST</MenuItem>
              <MenuItem value="Asia/Kolkata">IST</MenuItem>
            </Select>
            <TextField
              id="time"
              label="Start Time *"
              type="time"
              onChange={(e) =>
                setEventDetails((prev) => ({
                  ...prev,
                  eventStartTime: e.target.value,
                }))
              }
              value={eventDetails.eventStartTime}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              style={{ marginRight: "10px", marginTop: "5px" }}
            />
            <TextField
              id="time"
              label="End Time *"
              type="time"
              onChange={(e) =>
                setEventDetails((prev) => ({
                  ...prev,
                  eventEndTime: e.target.value,
                }))
              }
              value={eventDetails.eventEndTime}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              style={{ marginRight: "10px", marginTop: "5px" }}
            />
          </Grid>
        </Grid>

        {isSelectedOpenDialogBox === "create" && appointmentActions}

        {isSelectedOpenDialogBox === "edit" && (
          <div className="container" style={{ textAlign: "center" }}>
            <Button
              key="cancel"
              variant="contained"
              color="secondary"
              onClick={() => deleteCalanderEventByUid(eventDetails.eventId)}
              style={{ backgroundColor: "#FFF", color: "#000", margin: "5px" }}
            >
              Delete
            </Button>
            <Button
              key="save"
              type="submit"
              variant="contained"
              onClick={() => {
                insertOrUpdateCalander(0);
                handleClose();
              }}
              style={{
                border: "1px solid #FFF",
                color: "#FFF",
                backgroundColor: "#406882",
                margin: "5px",
              }}
            >
              Edit
            </Button>
          </div>
        )}
      </Dialog>

      {/* edit calander event dialog box */}
      <Dialog
        fullWidth={fullWidth}
        modal={false}
        open={openEditBox}
        onClose={handleClose}
        PaperProps={{ style: { overflow: "hidden", maxWidth: "400px", borderRadius: 16, boxShadow: '0 8px 32px rgba(64,104,130,0.18)' } }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#406882",
            color: "#FFF",
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 3,
            py: 2,
            fontSize: 18,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }}
        >
          <Typography variant="h6" sx={{ fontSize: 18, fontWeight: 600 }}>
            {`Meeting on ${moment(eventDetails.start).format("MMMM Do YYYY")}`}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{ color: '#FFF' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Card elevation={0} sx={{ boxShadow: 'none', borderRadius: 0 }}>
          <CardContent sx={{ px: 3, pt: 2, pb: 1 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#406882', mb: 0.5 }}>
                <EventIcon sx={{ fontSize: 20, mr: 1, verticalAlign: 'middle' }} />
                {eventDetails.title}
              </Typography>
              <Divider sx={{ mb: 1 }} />
              <Typography variant="body2" sx={{ color: '#555', mb: 1 }}>
                <strong>Date:</strong> {eventDetails.start ? moment(eventDetails.start).format('MMMM Do, YYYY') : ''}
              </Typography>
              <Typography variant="body2" sx={{ color: '#555', mb: 1 }}>
                <strong>Time:</strong> {eventDetails.eventStartTime ? eventDetails.eventStartTime.toString().slice(0, 5) : ''} - {eventDetails.eventEndTime ? eventDetails.eventEndTime.toString().slice(0, 5) : ''}
              </Typography>
            </Box>
            {attendees.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 500, color: '#406882', mb: 0.5 }}>
                  <PeopleIcon sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
                  Participants
                </Typography>
                <List dense>
                  {attendees.map((a, i) => (
                    <ListItem key={i} sx={{ pl: 0 }}>
                      <ListItemIcon sx={{ minWidth: 28 }}>
                        <PeopleIcon sx={{ fontSize: 16, color: '#406882' }} />
                      </ListItemIcon>
                      <ListItemText primary={<Typography variant="body2">{a}</Typography>} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <CiUser style={{ fontSize: 18, color: '#406882', marginRight: 6 }} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{user.full_name}</Typography>
              <Typography color="text.secondary" sx={{ ml: 1, fontSize: 12 }}>
                Organizer
              </Typography>
            </Box>
          </CardContent>
          <CardActions sx={{ px: 3, pb: 2, pt: 0, justifyContent: 'flex-end' }}>
            {selectedEventType === "USHoliday" ? (
              ""
            ) : (
              <>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#406882", color: "#FFF", fontWeight: 600, borderRadius: 2, px: 3, boxShadow: 'none', '&:hover': { backgroundColor: '#27496d' } }}
                  onClick={() => {
                    setOpenCreateEventDialog(true);
                    setIsSelectedOpenDialogBox("edit");
                  }}
                >
                  Edit
                </Button>
                &nbsp;
                <Button
                  variant="outlined"
                  sx={{ color: "#406882", borderColor: "#406882", fontWeight: 600, borderRadius: 2, px: 3, ml: 1, '&:hover': { borderColor: '#27496d', color: '#27496d' } }}
                  target="_blank"
                  href={eventDetails.teamsLink || ''}
                  disabled={!eventDetails.teamsLink}
                >
                  Join
                </Button>
              </>
            )}
          </CardActions>
        </Card>
      </Dialog>

      {/* Simple & Attractive Interview Details Dialog */}
      {/* {selectedInterview && (() => { console.log('selectedInterview:', selectedInterview); return null; })()} */}
      <Dialog
        open={openInterviewDialog}
        onClose={() => setOpenInterviewDialog(false)}
        maxWidth="xs"
        fullWidth
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: { xs: '12px', sm: '16px' },
            background: '#ffffff',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden',
            border: 'none',
            margin: { xs: '8px', sm: '32px' },
            maxHeight: { xs: '95vh', sm: '85vh' },
            height: 'auto',
          }
        }}
      >
        {/* Header with close button */}
        <Box
          sx={{
            position: 'relative',
            background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
            color: 'white',
            padding: { xs: '12px', sm: '16px' },
            textAlign: 'center',
          }}
        >
          <IconButton
            onClick={() => setOpenInterviewDialog(false)}
            sx={{
              position: 'absolute',
              top: { xs: 6, sm: 8 },
              right: { xs: 6, sm: 8 },
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              width: { xs: 28, sm: 32 },
              height: { xs: 28, sm: 32 },
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              }
            }}
          >
            <CloseIcon sx={{ fontSize: { xs: '16px', sm: '20px' } }} />
          </IconButton>

          <Box
            sx={{
              width: { xs: 36, sm: 44 },
              height: { xs: 36, sm: 44 },
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: { xs: '0 auto 8px', sm: '0 auto 12px' },
              fontSize: { xs: '16px', sm: '20px' },
            }}
          >
            🎯
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: '600',
              marginBottom: { xs: 0, sm: 0.5 },
              fontSize: { xs: '1rem', sm: '1.1rem' }
            }}
          >
            Interview Scheduled
          </Typography>
          <Typography
            variant="body2"
            sx={{
              opacity: 0.9,
              fontSize: { xs: '0.75rem', sm: '0.8rem' },
              display: { xs: 'none', sm: 'block' }
            }}
          >
            Here are your interview details
          </Typography>
        </Box>

        {selectedInterview && (
          <Box
            sx={{
              padding: { xs: '12px', sm: '16px 20px' },
              maxHeight: { xs: 'calc(95vh - 120px)', sm: 'calc(85vh - 140px)' },
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '2px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#c1c1c1',
                borderRadius: '2px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#a1a1a1',
              },
            }}
          >
            {/* Job Title - Main Focus */}
            <Box sx={{ textAlign: 'center', marginBottom: { xs: 1.5, sm: 2 } }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: '700',
                  color: '#1f2937',
                  marginBottom: { xs: 0.25, sm: 0.5 },
                  fontSize: { xs: '1.1rem', sm: '1.25rem' },
                  lineHeight: 1.2
                }}
              >
                {selectedInterview.jobtitle || 'Job Interview'}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#6b7280',
                  fontWeight: '500',
                  fontSize: { xs: '0.8rem', sm: '0.9rem' }
                }}
              >
                {selectedInterview.client_name || 'Company Interview'}
              </Typography>
            </Box>

            {/* Key Details in Simple Cards */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, sm: 1.5 } }}>

              {/* Date & Time Card */}
              <Box
                sx={{
                  background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                  borderRadius: { xs: '8px', sm: '10px' },
                  padding: { xs: '8px', sm: '12px' },
                  border: '1px solid #e5e7eb',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 } }}>
                  <Box
                    sx={{
                      width: { xs: 24, sm: 28 },
                      height: { xs: 24, sm: 28 },
                      borderRadius: '6px',
                      background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: { xs: '12px', sm: '14px' },
                      flexShrink: 0,
                    }}
                  >
                    📅
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: '600',
                        color: '#374151',
                        fontSize: { xs: '0.8rem', sm: '0.9rem' },
                        marginBottom: { xs: 0.25, sm: 0.5 }
                      }}
                    >
                      Schedule
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: '600',
                        color: '#1f2937',
                        display: 'block',
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        lineHeight: 1.2,
                        marginBottom: { xs: 0.25, sm: 0.25 }
                      }}
                    >
                      {selectedInterview.interview_date
                        ? formatDateWithTimezone(selectedInterview.interview_date)
                        : 'Date TBD'
                      }
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: '600',
                        color: '#4f46e5',
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        display: 'block'
                      }}
                    >
                      {selectedInterview.interview_time || 'Time TBD'}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Round & Contact Card */}
              <Box
                sx={{
                  background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                  borderRadius: { xs: '8px', sm: '10px' },
                  padding: { xs: '8px', sm: '12px' },
                  border: '1px solid #fbbf24',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 } }}>
                  <Box
                    sx={{
                      width: { xs: 24, sm: 28 },
                      height: { xs: 24, sm: 28 },
                      borderRadius: '6px',
                      background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: { xs: '12px', sm: '14px' },
                      flexShrink: 0,
                    }}
                  >
                    🎯
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: '600',
                        color: '#92400e',
                        fontSize: { xs: '0.8rem', sm: '0.9rem' },
                        marginBottom: { xs: 0.25, sm: 0.5 }
                      }}
                    >
                      Interview Details
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: '600',
                        color: '#92400e',
                        display: 'block',
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        marginBottom: { xs: 0.5, sm: 0.75 }
                      }}
                    >
                      Round: {selectedInterview.status}
                    </Typography>

                    {(selectedInterview.contact_no || selectedInterview.email_address) && (
                      <Box>
                        {selectedInterview.contact_no && (
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#92400e',
                              marginBottom: 0.25,
                              display: 'block',
                              fontSize: { xs: '0.65rem', sm: '0.7rem' }
                            }}
                          >
                            📞 {selectedInterview.contact_no}
                          </Typography>
                        )}
                        {selectedInterview.email_address && (
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#92400e',
                              fontSize: { xs: '0.65rem', sm: '0.7rem' },
                              display: 'block'
                            }}
                          >
                            ✉️ {selectedInterview.email_address}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>

              {/* Notes Card (if available) */}
              {selectedInterview.notes && (
                <Box
                  sx={{
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    borderRadius: { xs: '8px', sm: '10px' },
                    padding: { xs: '8px', sm: '12px' },
                    border: '1px solid #3b82f6',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 } }}>
                    <Box
                      sx={{
                        width: { xs: 24, sm: 28 },
                        height: { xs: 24, sm: 28 },
                        borderRadius: '6px',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: { xs: '12px', sm: '14px' },
                        flexShrink: 0,
                      }}
                    >
                      📝
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: '600',
                          color: '#1e40af',
                          fontSize: { xs: '0.8rem', sm: '0.9rem' },
                          marginBottom: { xs: 0.25, sm: 0.5 }
                        }}
                      >
                        Additional Notes
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#1e40af',
                          lineHeight: 1.3,
                          fontSize: { xs: '0.7rem', sm: '0.75rem' },
                          display: 'block'
                        }}
                      >
                        {selectedInterview.notes}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>

            {/* Action Buttons */}
            <Box sx={{ marginTop: { xs: 1.5, sm: 2 }, textAlign: 'center', paddingBottom: { xs: 1, sm: 0 } }}>
              <Button
                variant="contained"
                onClick={() => setOpenInterviewDialog(false)}
                sx={{
                  background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                  borderRadius: '8px',
                  padding: { xs: '8px 24px', sm: '10px 32px' },
                  fontWeight: '600',
                  fontSize: { xs: '0.8rem', sm: '0.9rem' },
                  textTransform: 'none',
                  boxShadow: '0 3px 8px rgba(79, 70, 229, 0.3)',
                  minHeight: { xs: '36px', sm: '40px' },
                  '&:hover': {
                    background: 'linear-gradient(135deg, #4338ca 0%, #6d28d9 100%)',
                    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.4)',
                    transform: 'translateY(-1px)',
                  },
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                Got it!
              </Button>
            </Box>
          </Box>
        )}
      </Dialog>

      {/* modal for creating a msal login */}
    </div>
  );
};

export default CalendarComponent;
